import { render, staticRenderFns } from "./CreateStructure.vue?vue&type=template&id=28261236&"
import script from "./CreateStructure.vue?vue&type=script&lang=ts&"
export * from "./CreateStructure.vue?vue&type=script&lang=ts&"
import style0 from "./CreateStructure.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports